<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="edit profile"
    (click)="onOpenEditLibraryDialog()"
    i18n-matTooltip="@@editProfileTooltip"
    matTooltip="Edit profile"
    [matTooltipShowDelay]="1000"
    [disabled]="currentLibrary.id === 0"
    i18n-aria-label="@@editProfileAriaLabel"
  >
    <mat-icon class="edit-icon">edit</mat-icon>
  </button>
</div>
